/**
 * Header Scroll Detection with Debounced Scroll Handling
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;
	const log = (...args) => {
		if (debug) console.log(...args);
	};

	const header = document.getElementById('header');

	if (!header) {
		log('Header element not found, exiting script.');
		return;
	}

	let lastScrollY = window.scrollY;
	let ticking = false;
	let timeout = null;

	const updateHeaderState = () => {
		const scrolledPast = window.scrollY > header.offsetHeight;

		if (scrolledPast !== header.classList.contains('--scrolled')) {
			header.classList.toggle('--scrolled', scrolledPast);
			log(`Scrolled ${scrolledPast ? 'past' : 'back to'} header height, --scrolled class ${scrolledPast ? 'added' : 'removed'}.`);
		}

		ticking = false;
	};

	const onScroll = () => {
		if (!ticking) {
			requestAnimationFrame(updateHeaderState);
			ticking = true;
		}

		clearTimeout(timeout);
		timeout = setTimeout(() => {
			requestAnimationFrame(updateHeaderState);
		}, 150);
	};

	window.addEventListener('scroll', onScroll, { passive: true });

	// Initial check in case page is already scrolled
	requestAnimationFrame(updateHeaderState);

	log('Scroll detection initialized.');
};
